import type { OrderStatus, PostStatus } from '@/api/types';

const WON = new Intl.NumberFormat('ko-KR');

export const formatWon = (value?: number | null) =>
  value == null ? '-' : `${WON.format(value)}원`;

export const formatNumber = (value?: number | null) => (value == null ? '-' : WON.format(value));

export function formatDate(value?: string | null, withTime = false): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  const pad = (n: number) => String(n).padStart(2, '0');
  const base = `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
  return withTime ? `${base} ${pad(date.getHours())}:${pad(date.getMinutes())}` : base;
}

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  PENDING: '결제 대기',
  PAID: '결제 완료',
  PREPARING: '상품 준비중',
  SHIPPING: '배송중',
  DELIVERED: '배송 완료',
  CONFIRMED: '구매 확정',
  CANCEL_REQUESTED: '취소 요청',
  CANCELED: '취소 완료',
  REFUND_REQUESTED: '환불 요청',
  REFUNDED_BEFORE_SHIPPING: '배송전 환불 완료',
  REFUNDED_AFTER_SHIPPING: '배송후 환불 완료',
};

/** 상태 뱃지 색상 클래스 (index.css 의 .badge--* 와 짝을 이룬다). */
export const ORDER_STATUS_TONE: Record<OrderStatus, string> = {
  PENDING: 'muted',
  PAID: 'info',
  PREPARING: 'info',
  SHIPPING: 'info',
  DELIVERED: 'success',
  CONFIRMED: 'success',
  CANCEL_REQUESTED: 'warn',
  CANCELED: 'danger',
  REFUND_REQUESTED: 'warn',
  REFUNDED_BEFORE_SHIPPING: 'muted',
  REFUNDED_AFTER_SHIPPING: 'muted',
};

export const POST_STATUS_LABEL: Record<PostStatus, string> = {
  OPEN: '접수',
  ANSWERED: '답변 완료',
  CLOSED: '종료',
};

/** 별점을 ★ 문자열로. */
export const stars = (rating: number) => '★'.repeat(rating) + '☆'.repeat(5 - rating);
